// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"592":"assets/libs/flatpickr/custom","2212":"assets/css/tupy","3706":"assets/libs/photoHandler/new-photoHandler","6690":"assets/css/pedro","7491":"assets/libs/fotorama/fotorama","8945":"assets/libs/fullcalendar/full_calendar","9331":"assets/css/filament"}[chunkId] + ".css";
};